'use client';

import { useMediaQuery, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import styled from 'styled-components';

import SideMenu from '@/ui/components/SideMenu';

const AsideBox = styled.aside`
  max-width: 400px;
  min-width: 300px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down(1050)} {
    max-width: 300px;
    order: 2;
  }
`;

const StickyBox = styled.div`
  position: sticky;
  top: 4rem;
`;

export default function Aside({ links }) {
  const isMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <>
      {isMdUp ? (
        <AsideBox>
          <StickyBox>
            <Box mt={6} style={{ order: 1 }}>
              <SideMenu heading="usefulLinks" items={links} />
            </Box>
          </StickyBox>
        </AsideBox>
      ) : (
        <Box mt={6} style={{ order: 1 }}>
          <SideMenu heading="usefulLinks" items={links} />
        </Box>
      )}
    </>
  );
}
